if (!customElements.get('kc-variant-offer')) {
  customElements.define('kc-variant-offer', class extends HTMLElement {
    connectedCallback() {
      this.refresh = this.refresh.bind(this);
      this.onVariant = (event) => {
        const section = this.closest('.shopify-section');
        if (section && !section.contains(event.target)) return;
        if (!event.detail?.variant || String(event.detail.variant.id) !== this.dataset.variantId) { this.invalidated = true; this.hidden = true; }
      };
      this.onChoice = (event) => {
        if (event.target.closest('variant-picker') && this.closest('.shopify-section')?.contains(event.target)) { this.invalidated = true; this.hidden = true; }
      };
      document.addEventListener('visibilitychange', this.refresh);
      document.addEventListener('on:variant:change', this.onVariant);
      document.addEventListener('change', this.onChoice);
      this.refresh();
    }
    refresh() {
      clearTimeout(this.timer);
      const format = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(Z|[+-]\d{2}:\d{2})$/;
      const start = Date.parse(this.dataset.start);
      const end = Date.parse(this.dataset.end);
      const valid = format.test(this.dataset.start) && format.test(this.dataset.end) && Number.isFinite(start) && Number.isFinite(end) && end > start;
      const now = Date.now();
      this.hidden = !(!this.invalidated && this.dataset.eligible === 'true' && valid && now >= start && now < end);
      if (valid) {
        const date = this.querySelector('time');
        if (date) date.textContent = new Intl.DateTimeFormat('en-GB', {day:'numeric', month:'long', hour:'2-digit', minute:'2-digit', hourCycle:'h23', timeZone:'Europe/London', timeZoneName:'short'}).format(end);
        if (now < end) this.timer = setTimeout(this.refresh, Math.min(60000, Math.max(1, (now < start ? start : end) - now)));
      }
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      document.removeEventListener('visibilitychange', this.refresh);
      document.removeEventListener('on:variant:change', this.onVariant);
      document.removeEventListener('change', this.onChoice);
    }
  });
}
